export {default as OrdersHistoryPage} from './OrdersHistoryPage';



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/index.ts